<template>
  <v-dialog @update:returnValue="setEditItemIdZero" v-model="dialogResult" max-width="500px" persistent>
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex>
          <v-select
            label="Event"
            :items="eventsList"
            v-model="itemData.events_id"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            textarea
            label="Message"
            v-model="itemData.message"
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-select
            label="Recipients"
            multiple
            :items="notificationRecipients"
            v-model="selectedRecipients"
          ></v-select>
        </v-flex>
        <v-flex>
          <v-checkbox
            label="Is active"
            v-model="itemData.is_active"
          ></v-checkbox>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemDataDecorator">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import eventsAPI from '@/api/resources/events'
  import recipientsAPI from '@/api/resources/recipients'
  import notificationsAPI from '@/api/resources/notifications'

  export default {
    mixins: [ dialogMixins ],
    data () {
      return {
        resource: 'notifications/whatsapp',
        notificationRecipients: [],
        eventsList: [],
        selectedRecipients: []
      }
    },
    methods: {
      editItemDataDecorator () {
        this.itemData.recipients = this.selectedRecipients

        this.editItemData()
      }
    },
    watch: {
      itemId (newVal, oldVal) {
        if (newVal > 0) {
          eventsAPI.loadEvents().then(result => {
            this.eventsList = result
          })

          recipientsAPI.loadRecipients().then(result => {
            notificationsAPI.getLinkedRecipients(newVal).then(result => {
              result.forEach((item, i) => {
                this.selectedRecipients.push(item.id)
              })
            })

            this.notificationRecipients = result
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditWhatsappNotificationsDialog.vue?6e75ea0c